import { type ComponentPropsWithRef } from "react";

import { cn } from "@/utils/cn";

const Flag = ({
  className,
  code,
  ...forwardedProps
}: ComponentPropsWithRef<"img"> & { code?: string }) => {
  return (
    <img
      alt={code || ""}
      src={`/flags/${code?.toLowerCase()}.svg`}
      className={cn(
        "position-relative inline-block w-[1.33333333rem] line-height-[1rem] object-cover",
        className
      )}
      {...forwardedProps}
    />
  );
};

export { Flag };
